export const COOKWARE_LABELS = Object.freeze({
  oven: 'Oven',
  stovetop: 'Stovetop',
  air_fryer: 'Air Fryer',
  instant_pot: 'Instant Pot',
  microwave: 'Microwave',
  grill: 'Grill',
  blender: 'Blender',
  no_cook: 'No Cook',
});

export function cookwareLabel(id) {
  return COOKWARE_LABELS[id] || id;
}
